import React, { useState, useEffect } from "react";
import { Button, Input, Table, Modal, Form, Select, message } from "antd";
import StyledCategoryPage from "./style";
import { SearchOutlined } from "@ant-design/icons";
import { ReactComponent as Delete1 } from "../../../../assets/Icons/delete1.svg";
import { ReactComponent as Edit1 } from "../../../../assets/Icons/edit1.svg";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import { ReactComponent as Deleted } from "../../../../assets/Icons/deleted.svg";
import PostUpdateData from "../../../../hooks/postUpdate";
import { useDispatch, useSelector } from "react-redux";
import { setGetCreateAllCustomPeople } from "../../../../Redux/systemSlice.js";
import FetchData from "../../../../hooks/FetchData.js";
const columns = (showEditModal, showDeleteModal) => [
  {
    title: "Name",
    dataIndex: "category_name",
    key: "category_name",
    width: "300px",
  },
  {
    title: "Parent Category",
    dataIndex: "parent_category",
    key: "parent_category",
    width: "350px",
  },
  {
    title: "Courses Under",
    dataIndex: "courses_under",
    key: "courses_under",
  },
  {
    title: "",
    key: "actions",
    render: (_, record) => (
      <div className="action-icons">
        <Edit1 className="edit-icon" onClick={() => showEditModal(record)} />
        <Delete1
          className="delete-icon"
          onClick={() => showDeleteModal(record.key)}
        />
      </div>
    ),
  },
];
const data = [
  {
    key: "1",
    name: "Design",
    parent_category: "Product Development",
    courses_under: "6",
  },
  {
    key: "2",
    name: "Design",
    parent_category: "Product Development",
    courses_under: "6",
  },
  {
    key: "3",
    name: "Design",
    parent_category: "Product Development",
    courses_under: "6",
  },
  {
    key: "4",
    name: "Design",
    parent_category: "Product Development",
    courses_under: "6",
  },
];
const Category = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteSuccessModalOpen, setIsDeleteSuccessModalOpen] =
    useState(false);
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
    setIsEditMode(false);
  };
  const showEditModal = (category) => {
    setSelectedCategory(category);
    form.setFieldsValue(category); // Prefill form with the selected category data
    setIsModalOpen(true);
    setIsEditMode(true); // Set to edit mode when showing the modal
  };
  const showDeleteModal = (categoryKey) => {
    setSelectedCategory(categoryKey);
    setIsDeleteModalOpen(true);
  };
  // const handleFormSubmit = async (values) => {
  //   try {
  //     const endPoint = isEditMode
  //       ? `/settings/updatecategory/${userInfo.clientId}/${selectedCategory.key}`
  //       : `/settings/addcategory/${userInfo.clientId}`;
  //     const method = isEditMode ? "PATCH" : "POST";

  //     const response = await PostUpdateData({
  //       endPoint,
  //       method,
  //       obj: {
  //         category_name: values.category_name,
  //         parent_category: values.parent_category,
  //         updated_at: new Date().toISOString(),
  //       },
  //     });
  //     if (response.statusCode === 200 || response.statusCode === 201) {
  //       setIsModalOpen(false);
  //       form.resetFields();

  //       if (isEditMode) {
  //         setIsSavedModalOpen(true); // Show "Saved" modal
  //         setTimeout(() => {
  //           setIsSavedModalOpen(false);
  //           handleGetCategoryData();
  //         }, 2000);
  //       } else {
  //         setIsCreateModalOpen(true); // Show "Created" modal
  //         setTimeout(() => {
  //           setIsCreateModalOpen(false);
  //           handleGetCategoryData();
  //         }, 2000);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error creating category:", error);
  //   }
  // };

  const handleFormSubmit = async (values) => {
    try {
      const endPoint = isEditMode
        ? `/settings/updatecategory/${userInfo.clientId}/${selectedCategory.key}`
        : `/settings/addcategory/${userInfo.clientId}`;
      const method = isEditMode ? "PATCH" : "POST";

      const response = await PostUpdateData({
        endPoint,
        method,
        obj: {
          category_name: values.category_name,
          parent_category: values.parent_category,
          updated_at: new Date().toISOString(),
        },
      });
      const isSuccess =
        (method === "POST" && response?.statusCode === 201) ||
        (method === "PATCH" && response?.status === 200);

      if (isSuccess) {
        setIsModalOpen(false);
        form.resetFields();

        if (isEditMode) {
          // Update the local state immediately after editing
          setData((prevData) =>
            prevData.map((item) =>
              item.key === selectedCategory.key
                ? {
                    ...item,
                    category_name: values.category_name,
                    parent_category: values.parent_category,
                  }
                : item
            )
          );

          setIsSavedModalOpen(true);
          setTimeout(() => setIsSavedModalOpen(false), 2000);
        } else {
          // Fetch updated data after adding a new category
          setIsCreateModalOpen(true);
          setParentCategories((prev) => [...prev, values.category_name]);
          setTimeout(() => {
            setIsCreateModalOpen(false);
            handleGetCategoryData();
          }, 2000);
        }
      } else {
        message.error(
          response?.message ||
            `Something went wrong while ${isEditMode ? "saving" : "creating"} the category`
        );
      }
    } catch (error) {
      console.error("Error creating/updating category:", error);
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          `Something went wrong while ${isEditMode ? "saving" : "creating"} the category`
      );
    }
  };

  const handleGetCategoryData = async () => {
    if (!userInfo.clientId) return;
    try {
      const response = await FetchData({
        endPoint: `/settings/getCategory/${userInfo.clientId}`,
      });
      if (response?.statusCode === 200 && response?.response?.length > 0) {
        const formattedData = response.response
          .map((item) => ({
            key: item.category_id,
            category_name: item.category_name,
            parent_category: item.parent_category,
            created_at: item.created_at,
          }))
          .reverse();
        dispatch(setGetCreateAllCustomPeople(formattedData)); // Store in Redux
        setData(formattedData); // Update local state
        const parentCategories = formattedData.map(
          (category) => category.category_name
        );
        setParentCategories(parentCategories);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };
  useEffect(() => {
    // See Settings > Account's index.js for why this depends on clientId
    // instead of running once on mount - same hard-refresh race.
    handleGetCategoryData();
  }, [userInfo.clientId]);

  const handleDeleteCategory = async () => {
    if (!selectedCategory) return;
    try {
      const response = await PostUpdateData({
        endPoint: `/settings/deletecategory/${userInfo.clientId}/${selectedCategory}`,
        method: "DELETE",
      });
      if (response?.status === 200) {
        setData(data.filter((item) => item.key !== selectedCategory));
        setIsDeleteSuccessModalOpen(true);
        setTimeout(() => {
          setIsDeleteSuccessModalOpen(false);
        }, 2000);
      } else {
        console.error("Failed to delete category:", response);
        message.error(response?.message || "Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to delete category"
      );
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedCategory(null);
    }
  };

  const filteredData = data.filter((item) =>
    item.category_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <>
      <StyledCategoryPage>
        <div>
          <div className="header-style">
            <div className="first-category">Categories</div>
            <div>
              <Button className="create-category-button" onClick={showModal}>
                + Create Category
              </Button>
            </div>
          </div>
          <br />
          <div className="category-count-search">
            <div>Total Categories: {data.length}</div>
            <div>
              <Input
                placeholder="Search name"
                prefix={<SearchOutlined style={{ color: "#636980" }} />}
                className="searchbar-style"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <br />
          <div>
            <Table
              columns={columns(showEditModal, showDeleteModal)}
              dataSource={filteredData}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-white" : "table-row-gray"
              }
              className="custom-table"
            />
          </div>
        </div>
      </StyledCategoryPage>
      <Modal
        width={631}
        height={416}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <StyledCategoryPage>
          <Form layout="vertical" form={form} onFinish={handleFormSubmit}>
            <div className="modal-title">
              {isEditMode ? "Editing Category" : "Creating Category"}
            </div>
            <br />
            <Form.Item
              name="category_name"
              label={<span className="label-style">Category Name</span>}
              rules={[
                { required: true, message: "Please enter the category name" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="parent_category"
              label={<span className="label-style">Parent Category</span>}
            >
              <Select placeholder="Select" allowClear>
                {parentCategories.map((category, index) => (
                  <Select.Option key={index} value={category}>
                    {category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <div className="button-container">
              <Button
                onClick={() => setIsModalOpen(false)}
                className="cancel-button"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="create-button"
                htmlType="submit"
              >
                {isEditMode ? "Save Changes" : "Create"}
              </Button>
            </div>
          </Form>
        </StyledCategoryPage>
      </Modal>
      <Modal
        open={isCreateModalOpen}
        footer={null}
        centered
        closable={false}
        width={198}
        height={100}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "36px", height: "36px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            Created
          </p>
        </div>
      </Modal>
      <Modal
        open={isSavedModalOpen}
        footer={null}
        centered
        closable={false}
        width={198}
        height={100}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "36px", height: "36px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            Saved
          </p>
        </div>
      </Modal>
      <StyledCategoryPage>
        <Modal
          width={440}
          height={177}
          title={
            <div
              style={{ fontSize: "18px", fontWeight: 500, textAlign: "left" }}
            >
              Delete
            </div>
          }
          open={isDeleteModalOpen}
          onCancel={() => setIsDeleteModalOpen(false)}
          footer={[
            <div style={{ display: "flex", marginLeft: "100px", gap: "20px" }}>
              <Button
                // className="cancel-button"
                key="cancel"
                onClick={() => setIsDeleteModalOpen(false)}
                style={{
                  width: "130px",
                  height: "34px",
                  padding: "6.5px 38.5px 6.5px 39.5px",
                  borderRadius: "8px",
                  border: "1px solid #1F243B",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                  }}
                >
                  Cancel
                </div>
              </Button>
              <Button
                key="delete"
                onClick={handleDeleteCategory}
                style={{
                  width: "130px",
                  height: "34px",
                  padding: "6.5px 40.5px 6.5px 41.5px",
                  borderRadius: "8px",
                  border: "1px solid #C2FAE5",
                  backgroundColor: "#C2FAE5",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                  }}
                >
                  Delete
                </div>
              </Button>
            </div>,
          ]}
          centered
          closable={false}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              textAlign: "left",
              color: "#636980",
            }}
          >
            Are you sure you want to delete this category?
          </p>
          <br />
        </Modal>
      </StyledCategoryPage>
      <Modal
        open={isDeleteSuccessModalOpen}
        footer={null}
        centered
        closable={false}
        width={198}
        height={100}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Deleted />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            Deleted
          </p>
        </div>
      </Modal>
    </>
  );
};
export default Category;
